module.exports = __webpack_public_path__ + "static/media/card-Visa-mobile.bb4ab1a7.svg";